export const WORKING_TIME_SETUP_CREATE_EDIT = "WORKING_TIME_SETUP_CREATE_EDIT";
export const WORKING_TIME_SETUP_CREATE_EDIT_SUCCESS = "WORKING_TIME_SETUP_CREATE_EDIT_SUCCESS";
export const WORKING_TIME_SETUP_CREATE_EDIT_ERROR = "WORKING_TIME_SETUP_CREATE_EDIT_ERROR";
export const WORKING_TIME_SETUP_DETAILS = "WORKING_TIME_SETUP_DETAILS";
export const WORKING_TIME_SETUP_DETAILS_SUCCESS = "WORKING_TIME_SETUP_DETAILS_SUCCESS";
export const WORKING_TIME_SETUP_DETAILS_ERROR = "WORKING_TIME_SETUP_DETAILS_ERROR";
export const WORKING_TIME_SETUP_DELETE = "WORKING_TIME_SETUP_DELETE";
export const WORKING_TIME_SETUP_DELETE_SUCCESS = "WORKING_TIME_SETUP_DELETE_SUCCESS";
export const WORKING_TIME_SETUP_DELETE_ERROR = "WORKING_TIME_SETUP_DELETE_ERROR";
export const WORKING_TIME_SETUPS_LIST = "WORKING_TIME_SETUPS_LIST";
export const WORKING_TIME_SETUPS_LIST_SUCCESS = "WORKING_TIME_SETUPS_LIST_SUCCESS";
export const WORKING_TIME_SETUPS_LIST_ERROR = "WORKING_TIME_SETUPS_LIST_ERROR";

